import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().when('simplifiedRegister', {
    is: true,
    then: yup.string().notRequired(),
    otherwise: yup.string().trim().required(),
  }),
  document: yup
    .string()
    .trim()
    .required()
    .when('international', {
      is: false,
      then: yup.string().cpfOrCnpj('Documento inválido'),
    }),
  segmentId: yup.object().notRequired().nullable(),
  description: yup.string(),
})

export default schema
